// ----------------------------------------------------------------------
// <copyright file='Izenda.BoardDetailHeader.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
! function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var convertToDateTimeFormat = require('share/utils/Izenda.ConvertToDateTimeFormat');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var uiState = require('logic/Izenda.UiState');  
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  const { get } = require('lodash/fp');

  module.exports = function(constants) {
    var BoardName = require('share/components/controls/Izenda.BoardName')(constants);
    var SearchCriteria = constants.SEARCH_CRITERIA;

    var BoardDetailHeader = React.createClass({
      propTypes: {
        store: React.PropTypes.object
      },

      handleToggleButton: function() {
        if (this.props.boardDetail.isEditMode) {
          return;
        }

        var boardDetail = this.props.boardDetail;
        boardDetail.setStateExpanded(!boardDetail.isShowDetail);
      },

      handleClickTitle: function(e) {
        e.stopPropagation();

        var props = this.props;
        var store = props.store;

        if (props.checkValidReport) {
          var previousLink = routeUtils.getPreviousLink();
          store.savePreviousLink && store.savePreviousLink(previousLink);
        }
        props.router.push(get('detailUri.pathname', props));
      },

      renderHeaderExpanded: function() {
        var props = this.props;
        var localization = props.localization;

        return (
          <GridLayout>
            <GridLayout.Row onClick={this.handleToggleButton}>
              <GridLayout.Col cols='3' xs='10'>
                <BoardName
                  onClick={this.handleClickTitle}
                  dataDetail={props.boardDetail}
                  {...props}
                />
              </GridLayout.Col>
              <GridLayout.Col cols='1' offset='8' className='text-right' xs='2'>
                <a title={localization.getText('COMMON_LABEL_COLLAPSE')}>
                  <span className='icon-minus-circled'></span>
                </a>
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
        );
      },

      renderHeaderCollapsed: function() {
        var props = this.props;
        var boardDetail = props.boardDetail;
        var model = props.store.items;
        var localization = props.localization;

        return (
          <GridLayout>
            <GridLayout.Row onClick={this.handleToggleButton}>
              <GridLayout.Col cols='2'>
                <a onClick={this.handleClickTitle}>
                  <TextHighLight
                    highlight={model.searchText}
                    text={boardDetail.name}
                    tooltip={boardDetail.name}
                    className='text-bold u_textBreak'
                    notHighlight={boardDetail.isNotHighLight(model.searchType, SearchCriteria[1].value) } />
                </a>
              </GridLayout.Col>
              <GridLayout.Col cols='6' className='overflow-text' title={boardDetail.description}>
                <TextHighLight
                  highlight={model.searchText}
                  text={boardDetail.description}
                  tooltip={boardDetail.description}
                  notHighlight={boardDetail.isNotHighLight(model.searchType, SearchCriteria[2].value)} />
              </GridLayout.Col>
              <GridLayout.Col cols='3' className='u_textGrayColor'>
                <p>
                  {localization.getText('COMMON_CRITERIA_CREATED_BY')}: &nbsp;
                  <TextHighLight
                      highlight={model.searchText}
                      text={boardDetail.createdBy}
                      notHighlight={boardDetail.isNotHighLight(model.searchType, SearchCriteria[3].value) } />
                </p>
                <p>
                 {localization.getText('COMMON_CRITERIA_LAST_EDITED')}: &nbsp;
                  <TextHighLight
                    highlight={model.searchText}
                    text={convertToDateTimeFormat(uiState.currentUser.dateFormat, boardDetail.modified) }
                    notHighlight={boardDetail.isNotHighLight(model.searchType, SearchCriteria[6].value) } />
                </p>
              </GridLayout.Col>
              <GridLayout.Col cols='1' className='text-right'>
                <a title={localization.getText('COMMON_LABEL_EXPAND')}>
                  <span className='icon-plus-circled'></span>
                </a>
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
        );
      },

      render: function() {
        var props = this.props;
        return (
          <div className='u_paddingAll'>
            {
              props.isExpanded
                ? this.renderHeaderExpanded()
                : this.renderHeaderCollapsed()
            }
          </div>
        );
      }

    });

    return connect()(BoardDetailHeader);
  };
} ();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.BoardDetailHeader.jsx